import request from '@/utils/request'

export function getv20a2000(param) {
    let data = param
    return request({
      url: `/v20/getv20a2000`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

 